<template>

<!--  <TopHeader />-->

  <WelcomeHeader />

  <HeroPage />

  <AppOverView />


  <OneAppSolution />

  <OurCourses />

  <OurFeatures />

  <LearnFree />

  <CurrentAffairsFree />

<!--  <UserExperience />-->

  <CoursePrice />

  <WelcomePageFaq />

  <WelcomeFooter />

</template>

<script >
// import TopHeader from "@/components/WelcomePages/TopHeader.vue";
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import HeroPage from "@/components/WelcomePages/HeroPage.vue";
import AppOverView from "@/components/WelcomePages/AppOverView.vue";
import OneAppSolution from "@/components/WelcomePages/OneAppSolution.vue";
import OurCourses from "@/components/WelcomePages/OurCourses.vue";
import OurFeatures from "@/components/WelcomePages/OurFeatures.vue";
import LearnFree from "@/components/WelcomePages/LearnFree.vue";
import CurrentAffairsFree from "@/components/WelcomePages/CurrentAffairsFree.vue";
import WelcomePageFaq from "@/components/WelcomePages/WelcomePageFaq.vue";
// import UserExperience from "@/components/WelcomePages/UserExperience.vue";
import CoursePrice from "@/components/WelcomePages/CoursePrice.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import store from "@/store";
import {StaticTags} from "@/static";
import {onMounted} from "vue";
import {useRouter} from "vue-router";
export default {
  components: {
    WelcomeFooter,
    WelcomePageFaq,
    CoursePrice,
    // UserExperience,
    LearnFree,
    CurrentAffairsFree,
    OurFeatures,
    OurCourses,
    AppOverView,
    HeroPage,
    // TopHeader,
    WelcomeHeader,
    OneAppSolution
  },

  setup() {
    const router = useRouter();
    const access_token = store.getters[StaticTags.GET_ACCESS_TOKEN];
    const isLoggedIn = (access_token && access_token != "null" && access_token != undefined)
    onMounted(()=>{
      if (isLoggedIn) {
        router.push('/home');
      } else {
        router.push('/');
      }

    })
    return {

    };
  },

};
</script>

<style>


.section {
  padding-top: 100px;
  position: relative;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .section {
    padding-top: 60px;
  }
}

@media (max-width: 767px) {
  .section {
    padding-top: 50px;
  }
}


.section-title {
  text-align: center;
  margin-bottom: 80px;
  position: relative;
  z-index: 5;
}

.section-title h3 {
  font-size: 15px;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
  color: #ff6b81;
  text-transform: uppercase;
}

.section-title h2 {
  margin-bottom: 25px;
  text-transform: capitalize;
  position: relative;
  font-family: Noto Sans;
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;

}

.section-title p {
  font-family: Noto Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.5px;
  text-align: center;

}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .section-title {
    margin-bottom: 70px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .section-title {
    margin-bottom: 70px;
  }
  .section-title h3 {
    font-size: 14px;
  }
  .section-title h2 {
    font-size: 28px;
    line-height: 32px;
    margin-bottom: 20px;
  }
  .section-title p {
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  .section-title {
    margin-bottom: 60px;
  }
  .section-title h3 {
    font-size: 14px;
  }
  .section-title h2 {
    font-size: 28px;
    line-height: 35px;
    margin-bottom: 18px;
  }
  .section-title p {
    font-size: 14px;
  }
}

.section-title.align-right {
  padding: 0;
  padding-left: 600px;
}

.section-title.align-right h2:before {
  display: none;
}

.section-title.align-right h2:after {
  position: absolute;
  right: 0;
  bottom: -1px;
  height: 2px;
  width: 50px;
  background: #ff6b81;
  content: "";
}

.section-title.align-left {
  padding: 0;
  padding-right: 600px;
}

.section-title.align-left h2:before {
  left: 0;
  margin-left: 0;
}

/* ===== Premium section header (shared across welcome sections) ===== */
.premium-head {
  text-align: center;
  margin-bottom: 48px;
  padding-top: 8px;
}

.premium-head .ph-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: "Noto Sans", sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0066CC;
  background: linear-gradient(135deg, rgba(0, 149, 255, 0.13), rgba(0, 149, 255, 0.04));
  border: 1px solid rgba(0, 149, 255, 0.28);
  padding: 7px 18px;
  border-radius: 50px;
  margin-bottom: 18px;
  box-shadow: 0 2px 12px rgba(0, 149, 255, 0.08);
}

.premium-head .ph-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0095FF;
  box-shadow: 0 0 0 4px rgba(0, 149, 255, 0.18);
}

.premium-head h2 {
  font-family: "Noto Sans", sans-serif;
  font-size: clamp(1.55rem, 3.2vw, 2.2rem);
  font-weight: 800;
  color: #191b47;
  margin-bottom: 14px;
  line-height: 1.32;
  letter-spacing: -0.01em;
}

.premium-head p {
  font-family: "Noto Sans", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #64748b;
  margin: 0 auto;
  max-width: 580px;
  line-height: 1.65;
}

.premium-head .ph-line {
  width: 64px;
  height: 4px;
  border-radius: 4px;
  margin: 18px auto 0;
  background: linear-gradient(90deg, #0095FF, #38B6FF);
}

@media (max-width: 767px) {
  .premium-head {
    margin-bottom: 34px;
  }
  .premium-head p {
    font-size: 0.9rem;
    max-width: 90%;
  }
}
</style>